import { Injectable, OnDestroy } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { Observable, of, Subscription } from "rxjs";
import { filter, first } from "rxjs/operators";
import { UnleashService } from "src/app/shared/services/unleash.service";

@Injectable({
  providedIn: "root",
})
export class GuestCheckoutGuard implements OnDestroy {
  constructor(
    private readonly unleashService: UnleashService,
    private router: Router
  ) {}

  readonly enableGuestCheckout$: Observable<boolean> = this.unleashService
    .enableGuestCheckout$;
  enableGuestCheckout: boolean = false;
  subs: Subscription = new Subscription();

  canActivate(): Observable<boolean | UrlTree> {
    this.subs.add(
      this.enableGuestCheckout$
        .pipe(
          filter((val) => val),
          first()
        )
        .subscribe((flag) => {
          this.enableGuestCheckout = flag;
        })
    );

    if (!!this.enableGuestCheckout) {
      return of(true);
    } else {
      this.router.navigateByUrl("/");
      return of(false);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
